import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { BreadcrumbMktComponent } from "../breadcrumb-mkt/breadcrumb-mkt.component";
import { NgForOf, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { SucursalHorariosService } from './services/sucursal-horarios.service';
import { NotificationsComponent } from "../../../notifications/notifications.component";

@Component({
  selector: 'app-sucursal-horarios',
  standalone: true,
  imports: [
    BreadcrumbMktComponent,
    NgForOf,
    RouterLink,
    ReactiveFormsModule,
    NgIf,
    NotificationsComponent
  ],
  templateUrl: './sucursal-horarios.component.html',
  styleUrl: './sucursal-horarios.component.css'
})
export class SucursalHorariosComponent implements OnInit {
  @ViewChild('addAndUpdateSucursalHorario') addAndUpdateSucursalHorario!: ElementRef;
  @ViewChild('deleteSucursalHorario') deleteSucursalHorario!: ElementRef;
  title = 'Sucursal Horarios';
  route = '/dashboardmkt/sucursalesHorarios';
  formDataForCreateSucursalHorario: FormGroup = new FormGroup({});
  formCreateSucursalHorario: FormGroup = new FormGroup({});
  dataSucursalesHorarios: any[] = [];
  dataSucursalHorario: any = {};
  idRemover: string = '';

  constructor(
    private fb: FormBuilder,
    private sucursalHorariosService: SucursalHorariosService
  ) {}

  ngOnInit() {
    this.formDataForCreateSucursalHorario = this.fb.group({
      _id: [''],
      ciudad: ['', Validators.required],
      direccionSucursal: ['', Validators.required],
      nameEmpresa: ['Medilink', Validators.required],
      nameSucursal: ['', Validators.required],
      linkMaps: ['', Validators.required],
      horarioEntreSemanaEntrada: ['', Validators.required],
      horarioEntreSemanaSalida: ['', Validators.required],
      horarioSabadoEntrada: ['', Validators.required],
      horarioSabadoSalida: ['', Validators.required],
      horarioDomingoEntrada: ['', Validators.required],
      horarioDomingoSalida: ['', Validators.required],
    });
    this.formCreateSucursalHorario = this.fb.group({
      ciudad: ['', Validators.required],
      direccionSucursal: ['', Validators.required],
      nameEmpresa: ['Medilink', Validators.required],
      nameSucursal: ['', Validators.required],
      linkMaps: ['', Validators.required],
      horarioEntreSemana: ['', Validators.required],
      horarioSabado: ['', Validators.required],
      horarioDomingo: ['', Validators.required],
    });

    this.getAllDataSucursalHorario();
  }

  enviarData() {
    if (this.formDataForCreateSucursalHorario.valid) {
      const {
        horarioEntreSemanaEntrada,
        horarioEntreSemanaSalida,
        horarioSabadoEntrada,
        horarioSabadoSalida,
        horarioDomingoEntrada,
        horarioDomingoSalida,
        ciudad,
        direccionSucursal,
        nameEmpresa,
        nameSucursal,
        linkMaps
      } = this.formDataForCreateSucursalHorario.value;

      this.formCreateSucursalHorario.patchValue({
        ciudad: ciudad,
        linkMaps: linkMaps,
        direccionSucursal: direccionSucursal,
        nameEmpresa: nameEmpresa,
        nameSucursal: nameSucursal,
        horarioEntreSemana: `${horarioEntreSemanaEntrada} a ${horarioEntreSemanaSalida}`,
        horarioSabado: `${horarioSabadoEntrada} a ${horarioSabadoSalida}`,
        horarioDomingo: `${horarioDomingoEntrada} a ${horarioDomingoSalida}`
      });

      if (this.formDataForCreateSucursalHorario.value._id) {
        this.sucursalHorariosService.updateDataSucursalHorario(
          this.formDataForCreateSucursalHorario.value._id,
          this.formCreateSucursalHorario.value,
          this.addAndUpdateSucursalHorario
        );
        this.getAllDataSucursalHorario();
      } else {
        this.sucursalHorariosService.createDataSucursalHorario(
          this.formCreateSucursalHorario.value,
          this.addAndUpdateSucursalHorario
        );
        this.getAllDataSucursalHorario();
      }
    }
  }

  setRemover(id: string) {
    this.idRemover = id;
  }



  resetFormulario() {
    this.formDataForCreateSucursalHorario.reset({
      ciudad: '',
      direccionSucursal: '',
      nameEmpresa: 'Medilink',
      nameSucursal: '',
      horarioEntreSemanaEntrada: '',
      horarioEntreSemanaSalida: '',
      horarioSabadoEntrada: '',
      horarioSabadoSalida: '',
      horarioDomingoEntrada: '',
      horarioDomingoSalida: '',
      _id: ''
    });
  }

  removeDataHorario(id: string) {
    this.sucursalHorariosService.removeDataHorario(id, this.deleteSucursalHorario);
    this.getAllDataSucursalHorario();
  }

  getAllDataSucursalHorario() {
    try {
      this.sucursalHorariosService.getAllDataSucursalHorario()
        .subscribe((result: any) => {
          this.dataSucursalesHorarios = result.data.getAllDataHorarios;
        });
    } catch (error) {
      console.error(error);
    }
  }

  async getDataSucursalHorarioById(id: string) {
     this.sucursalHorariosService.getDataSucursalHorarioById(id).subscribe((result: any ) => {
      this.dataSucursalHorario = result.data.getDataSucursalHorarioById;
      const { _id, ciudad, direccionSucursal, nameEmpresa, nameSucursal, linkMaps } = result.data.getDataSucursalHorarioById;
      this.formDataForCreateSucursalHorario.patchValue({
        ciudad: ciudad,
        direccionSucursal: direccionSucursal,
        nameEmpresa: nameEmpresa,
        nameSucursal: nameSucursal,
        linkMaps: linkMaps,
        _id: _id
      });
    });
  }
}
